import React from 'react';
import classnames from 'classnames';
import styles from './title.module.css';

type TitleProps = {
  children: React.ReactNode;
  className?: string;
};

export const Title = ({ children, className }: TitleProps) => (
  <div className={classnames(styles.title, className)}>{children}</div>
);
